export default "__VITE_ASSET__2101372d__"